module.exports = __webpack_public_path__ + "media/styles/images/svg/x-gray-c299f4c3599554a862c09bb4080a821e.svg";